/**
 * Updates the current URL by merging new search parameters.
 * - If a value is undefined, the key will be removed.
 * - Otherwise, the key will be updated or added.
 *
 * @param searchParams - An object containing key/value pairs to update the query string.
 * @returns A new URL instance with the updated search parameters.
 */
export const updateCurrentUrlSearchParams = (
  searchParams: Record<string, string | undefined>
): URL => {
  const url = new URL(window.location.href);

  Object.entries(searchParams).forEach(([key, value]) => {
    if (value === undefined) {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
  });

  return url;
};

/**
 * Returns the value of a search parameter from the current URL.
 *
 * @param {string} parameter - The name of the parameter to retrieve.
 * @returns {string | undefined} The value of the parameter, or `undefined` if the parameter does not exist.
 */
export const getSearchParameter = (parameter: string) => {
  const searchParams = new URL(window.location.href).searchParams;

  return searchParams.get(parameter) ?? undefined;
};
